// extracted by mini-css-extract-plugin
module.exports = {"blockContainer":"blockContainer-module--blockContainer--1Ffmc","blockContainerOverflowTop":"blockContainer-module--blockContainerOverflowTop--1cft8"};